"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToEndOfDay = exports.convertToStartOfDay = exports.getNumberOfDaysBetweenDates = exports.getShortDayOfWeekName = exports.getDayOfTheWeekName = exports.convertTimeToAmPm = void 0;
const convertTimeToAmPm = (time) => {
    const timeString12hr = new Date('1970-01-01T' + time + 'Z').toLocaleTimeString('en-GB', {
        timeZone: 'UTC',
        hour12: true,
        hour: 'numeric',
        minute: 'numeric',
    });
    return timeString12hr.split(' ').join('');
};
exports.convertTimeToAmPm = convertTimeToAmPm;
const getDayOfTheWeekName = (url) => new URL(url).pathname.match(/[a-zA-Z]/g).join('');
exports.getDayOfTheWeekName = getDayOfTheWeekName;
const getShortDayOfWeekName = (url) => {
    const dayOfWeekName = (0, exports.getDayOfTheWeekName)(url);
    return dayOfWeekName.slice(0, 3);
};
exports.getShortDayOfWeekName = getShortDayOfWeekName;
const getNumberOfDaysBetweenDates = (startDate, endDate) => {
    const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
    const start = (0, exports.convertToStartOfDay)(new Date(startDate));
    const end = (0, exports.convertToEndOfDay)(new Date(endDate));
    const diffInMilliseconds = end.getTime() - start.getTime();
    const daysDiff = Math.ceil(diffInMilliseconds / oneDayInMilliseconds);
    return daysDiff;
};
exports.getNumberOfDaysBetweenDates = getNumberOfDaysBetweenDates;
const convertToStartOfDay = (date) => {
    const startOfDay = new Date(date);
    startOfDay.setHours(0, 0, 0, 0);
    return startOfDay;
};
exports.convertToStartOfDay = convertToStartOfDay;
const convertToEndOfDay = (date) => {
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);
    return endOfDay;
};
exports.convertToEndOfDay = convertToEndOfDay;
